export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ06.8aa23b84.mp3";